import {_post,_get} from "./Axios";
import LocalRepository from "../LocalRepository";

export default class DbApi {
    static compare() {
        return _get('utils/DbInsight/structure_compare')
    }

    static sync(server, table, column) {
        return _post('utils/DbInsight/sync', {
            server,
            table,
            column,
        })
    }

    static copyToDummy(booking_id) {
        return _post('utils/DbInsight/copy_to_dummy', {
            booking_id
        })
    }

    static table() {
        return _get('utils/DbInsight/table')
    }

    static copyData(table) {
        return _post('utils/DbInsight/copy_data', {
            table
        })
    }
}